/**
 * Standardized currency formatting utility for AcquireOS.
 * 
 * - For values >= $1,000,000, formats in millions with 2 decimal places (e.g., $3.20MM or -$1.82MM).
 * - For values < $1,000,000, formats as standard localized currency (e.g., $350,000) rounded to a whole number unless decimals are requested.
 */
export function formatCurrency(n, options = {}) {
  const value = Number(n);
  if (isNaN(value)) return '$0';

  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  if (abs >= 1_000_000) {
    const precision = options.precision !== undefined ? options.precision : 2;
    const mm = (abs / 1_000_000).toFixed(precision);
    return `${sign}$${mm}MM`;
  }

  const decimals = options.decimals !== undefined ? options.decimals : 0;
  if (decimals > 0) {
    const formatted = abs.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${sign}$${formatted}`;
  }

  return `${sign}$${Math.round(abs).toLocaleString()}`;
}
